import es_ES from './es_ES';

export default {
  es_ES,
};
